import { SectionNames } from '@/analytics/sectionNames';
import { performVWBasicButtonClick } from '@/analytics/events';
import { useTribalContext } from '@/context/tribal';
import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import { getActiveConfiguration } from '@/modules/utils/storeUtils';
import { getBanner, BannerType } from '@/modules/utils/banners';
import { Banner } from '@tribal-worldwide-london/ui-component-library-vwg';

function ServicePlanBanner() {
  const { analyticsManager, analyticsBuilder } = useTribalContext();
  const { retailers } = useGlobalStore((state) => state.app);

  const { app } = useGlobalStore();
  const activeConfiguration: GlobalStoreStateConfiguration | undefined =
    getActiveConfiguration(app);

  const fleetMode = activeConfiguration?.pdbData?.fleetMode || false;

  const banner = getBanner(
    fleetMode ? BannerType.ServiceFleet : BannerType.ServiceRetail
  );

  if (!banner) return;

  const onClickHandler = () => {
    window.open(banner.href, '_blank');
    performVWBasicButtonClick({
      label: banner.cta,
      sectionName: SectionNames.SERVICE_PLAN_BANNER,
      configuration: activeConfiguration,
      retailers,
      analyticsManager,
      analyticsBuilder,
    });
  };

  return (
    <Banner
      title={banner.title}
      titleBold={banner.titleBold}
      copy={banner.copy}
      cta={{
        text: banner.cta,
        onClick: onClickHandler,
      }}
      image={banner.image}
      imageAlt={banner.imageAlt}
      termsAndConditions={banner.terms}
    />
  );
}

export default ServicePlanBanner;
